import { tEnum } from '@components/i18n';
import { CamelCaseKeys } from '@utils/typescript';
import { Company as CompanyModel } from './Company';
import { BusinessPartner } from './BusinessPartner';

export enum Genders {
  Male = 'male',
  Female = 'female',
}

export type UserLess = CamelCaseKeys<{
  id: number;
  name: string;
  name_km: string;
  gender: Genders;
  dob: string;
  mobile_number?: string;
  occupation?: string;
  email?: string;
  address?: string;
}>;

export type UserList = CamelCaseKeys<{
  id: number;
  name: string;
}>;

export type User = CamelCaseKeys<{
  id: number;
  gender: Genders;
  height: number;
  weight: number;
  bmi: number;
  dob: string;
  occupation: string;
  personal_code: string;
  email: string;
  no_mobile_number: boolean;
  mobile_number?: string;
  address: string;
  name: string;
  name_km: string;
  access_token: string;
  business_partner: BusinessPartner;
}>;

export type CompanyUser = CamelCaseKeys<{
  id: number;
  name: string;
  company: CompanyModel;
}>;

export const tGender = (gender?: Genders) => tEnum('genders', gender);

export const dUserName = (user?: Pick<User, 'name' | 'nameKm'>) => {
  if (!user) return '';
  const { name, nameKm } = user;
  return name ? name : nameKm;
};
